/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Ladder } from './Ladder';
import {
    LadderFromJSON,
    LadderFromJSONTyped,
    LadderToJSON,
    LadderToJSONTyped,
} from './Ladder';

/**
 * 
 * @export
 * @interface GetLadderResponse
 */
export interface GetLadderResponse {
    /**
     * 
     * @type {Ladder}
     * @memberof GetLadderResponse
     */
    ladder: Ladder;
}

/**
 * Check if a given object implements the GetLadderResponse interface.
 */
export function instanceOfGetLadderResponse(value: object): value is GetLadderResponse {
    if (!('ladder' in value) || value['ladder'] === undefined) return false;
    return true;
}

export function GetLadderResponseFromJSON(json: any): GetLadderResponse {
    return GetLadderResponseFromJSONTyped(json, false);
}

export function GetLadderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLadderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ladder': LadderFromJSON(json['ladder']),
    };
}

export function GetLadderResponseToJSON(json: any): GetLadderResponse {
    return GetLadderResponseToJSONTyped(json, false);
}

export function GetLadderResponseToJSONTyped(value?: GetLadderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ladder': LadderToJSON(value['ladder']),
    };
}

